var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "topbar" },
    [
      _c("router-link", { staticClass: "topbar-logo", attrs: { to: "/" } }, [
        _c("img", {
          attrs: {
            src: require("../../assets/logo/topbar-login.png"),
            alt: "",
          },
        }),
        _vm._v(" "),
        _c("h1", [_vm._v(_vm._s(_vm.title))]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: { "fixed-header": _vm.fixedHeader } },
        [_c("tags-view")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "topbar-right",
          on: {
            mouseover: function ($event) {
              _vm.isShow = true
            },
            mouseout: function ($event) {
              _vm.isShow = false
            },
          },
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.unit) + " - " + _vm._s(_vm.name))]),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShow,
                  expression: "isShow",
                },
              ],
              staticClass: "user-hide-list",
            },
            [
              _c("li", { staticClass: "logout", on: { click: _vm.logout } }, [
                _vm._v("退出"),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }